import { useFormContext } from 'react-hook-form';
import { ConnectedSkillAutocomplete } from 'shared/components';

import { CandidateProfileFormData } from '../../../types';
import LargerInputContainer from './LargerInputContainer';

export default function FieldSkills() {
    const { control } = useFormContext<CandidateProfileFormData>();

    return (
        <LargerInputContainer>
            <ConnectedSkillAutocomplete
                control={ control }
                name="skills"
                multiple
            />
        </LargerInputContainer>
    );
}
